import { render, staticRenderFns } from "./BetaAccesspopup.vue?vue&type=template&id=bd2ec082"
import script from "./BetaAccesspopup.vue?vue&type=script&lang=js"
export * from "./BetaAccesspopup.vue?vue&type=script&lang=js"
import style0 from "./BetaAccesspopup.vue?vue&type=style&index=0&id=bd2ec082&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports